import { useMemo } from 'react';
import { Company } from 'api';
import { OwnershipOption, UseOwnershipOptionsProps } from './useOwnershipOptions.props';

// Owner choices mirror backend validation: any firm fund, plus HOLDING child companies.
export const useOwnershipOptions = ({ companyInfo, fundList }: UseOwnershipOptionsProps): OwnershipOption[] =>
  useMemo(() => {
    const funds = (fundList ?? [])
      .filter(fund => fund.id !== undefined)
      .map<OwnershipOption>(fund => ({
        id: `fund-${fund.id}`,
        value: `fund-${fund.id}`,
        label: fund.name ?? '',
        type: 'fund',
      }));

    const companies = (companyInfo?.child_companies ?? [])
      .filter(child => child.company_type === Company.type.HOLDING)
      .map<OwnershipOption>(child => ({
        id: `company-${child.company_id}`,
        value: `company-${child.company_id}`,
        label: child.company_name,
        type: 'company',
      }));

    return [...funds, ...companies];
  }, [companyInfo, fundList]);
